<div mat-dialog-content class="wrapper">
	<form [formGroup]="form">
		<app-mobility-calculator [resetNumber$]="submitQuantity$" (numberChange)="quantityChanged($event)"></app-mobility-calculator>
	</form>
</div>

<div mat-dialog-actions class="justify-between">
	<button mat-stroked-button (click)="close()">סגור</button>
	<button mat-raised-button cdkFocusInitial style="background: var(--valid-color); color: var(--secondary-color); width: 50%; font-size: 2rem" (click)="onSubmit()">+</button>
</div>
